import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {  getActiveSession } from "../../services/ActivePrograms";
import ViewSessionDetails from "./ViewSessionDetails";
import ViewSessionNotes from "./ViewSessionNotes";
import ViewSessionNoteEdit from "./ViewSessionNoteEdit";
import ViewSessionNoteDetails from "./ViewSessionNoteDetails";
import ViewSessionGroupNoteEdit from "./ViewSessionGroupNoteEdit";
import ViewSessionGroupNoteDetails from "./ViewSessionGroupNoteDetails";


const ViewSession = ({state,onclick,target,toggle,content,setNavbar,getSessionById}) => {
  
  const [notes,setNotes] = useState({})
  const [member,setMember] = useState();
  const [viewMode,setViewMode] = useState(null)

  const getSessionNotes = async() => {
      try {
        const response = await getActiveSession(state.programId)
        console.log(response.data.data.filter((session)=>session._id === state._id)[0])
        setNotes(response.data.data.filter((session)=>session._id === state._id)[0])
      } catch (error) {
        console.log(error)
      }
}
  return (
    <>
      <div className="col-md-12">
          {viewMode === "sessionNotes" && <ViewSessionNotes setViewMode={setViewMode} state={state} member={member} setMember={setMember}/> }
          {!viewMode && <ViewSessionDetails setViewMode={setViewMode} getSessionById={getSessionById} getSessionNotes={getSessionNotes}  state={state} notes={notes} setNavbar={setNavbar} onclick={onclick} toggle={toggle} target={target} content={content}/>}
          {viewMode === "sessionNoteEdit" && member && <ViewSessionNoteEdit setViewMode={setViewMode} state={state} member={member} getSessionNotes={getSessionNotes} notes={notes}/>}
          {viewMode === "sessionNoteDetails" && member && <ViewSessionNoteDetails setViewMode={setViewMode} state={state} member={member} notes={notes}/>}
          {viewMode === "sessionGroupNoteEdit" && <ViewSessionGroupNoteEdit setViewMode={setViewMode} state={state} member={member}/>}
          {viewMode === "sessionGroupNoteDetails" && <ViewSessionGroupNoteDetails setViewMode={setViewMode} state={state} member={member}/>}
      </div>
    </>
  );
};

export default ViewSession;
